import { useMovieContext } from "../context/MovieContext";
import "../css/MovieCard.css";

const MovieCard = ({ movie }) => {
  const { isFavorite, addToFavorites, removeFromFravorites } =
    useMovieContext();
  const favorite = isFavorite(movie.id);

  const onfavoriteClick = (e) => {
    e.preventDefault();
    if (favorite) removeFromFravorites(movie.id);
    else addToFavorites(movie);
  };

  return (
    <div className="movie-card">
      <div className="movie-poster">
        <img
          src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
          alt={movie.title}
        />
        <div className="movie-overlay">
          <button
            className={`favorite-btn ${favorite ? "active" : ""}`}
            onClick={onfavoriteClick}
          >
            ♥
          </button>
        </div>
      </div>
      <div className="movie-info">
        <h3>{movie.title}</h3>
        <p>{movie.release_date}</p>
        <p>{movie.overview}</p>
        <p>{movie.vote_average}</p>
      </div>
    </div>
  );
};

export default MovieCard;
